import React from 'react'
import { Card, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts/auth';
import { DataspaceConnector } from '../../models/DataSpace';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import classNames from 'classnames';

type Props = {
  connector: DataspaceConnector;
  onEdit?: () => void;
  onDelete?: () => void;
  actions?: React.ReactNode;
  className?: string;
}

export default function DataspaceConnectorItem({ connector, className, actions, onEdit, onDelete }: Props) {
  const { loggedUser } = useAuth();

  return (
    <Card className={classNames(className, "shadow-sm")}>
      <Card.Body className="py-2 overflow-hidden">
        <Link to={`/dataspace-connectors/${connector.id}`}>
          <Card.Title className="d-inline lh-base mb-0 mw-100 text-truncate">{connector.name}</Card.Title>
        </Link>
        <p className="line-clamp-2 text-secondary mb-3">{connector.description}</p>

        <Row className="justify-content-center">
          {actions || (loggedUser?.sub === connector.ownershipInfo?.ownerId && (
            <>
              <button className="circle-button dark ms-2" onClick={onEdit}>
                <FontAwesomeIcon icon={solid('pen')} />
              </button>
              <button className="circle-button dark ms-2" onClick={onDelete}>
                <FontAwesomeIcon icon={solid('trash')} />
              </button>
            </>
          ))}
        </Row>
      </Card.Body>
    </Card>
  )
}